<template>
  <div class="overflow-y-hidden overflow-x-scroll">
    <table class="min-w-full divide-y divide-gray-200" :class="getTableClass()">
      <thead class="bg-gray-50">
        <slot name="header" v-if="customHeader"></slot>
        <tr v-else>
          <th
            v-for="(item, index) in json.header.data"
            v-bind:key="item.text"
            :data-sort-ignore="getSortedStatus('sort', index)"
            :style="getAttr(index, json.header, 'style')"
            :class="getAttr(index, json.header, 'class')"
            scope="col"
            class="
              px-2
              py-3
              text-left text-xs
              font-medium
              text-gray-500
              uppercase
              whitespace-nowrap
            "
            v-html="getHeader(item, index)"
          ></th>
          <th
            v-if="hasChecker()"
            class="
              px-1
              py-3
              text-left text-xs
              font-medium
              text-gray-500
              uppercase
              whitespace-nowrap
            "
          >
            <div class="relative flex items-center justify-start">
              <div class="flex items-center h-5 mr-1">
                <input
                  v-tooltip="$t('message.' + checker.header_title)"
                  id="checkbox-all"
                  type="checkbox"
                  value="'checkbox-all'"
                  class="
                    focus:ring-indigo-500
                    h-4
                    w-4
                    border-gray-300
                    rounded
                  "
                  :class="!hasData ? 'text-indigo-400 ' : 'text-indigo-600'"
                  :disabled="!hasData"
                  @click="checkClick('checkbox-all')"
                />
              </div>
              <div class="flex items-center">
                <label
                  for="checkbox-all"
                  class="font-medium text-xs text-gray-500"
                  v-html="$t('message.' + checker.title)"
                ></label>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <template v-if="!loading">
          <tr
            v-for="(item, i) in json.body.data"
            :class="[getRowAttr(item), getBodyClass()]"
            @click="rowClick(item)"
            :key="i"
          >
            <td
              v-if="index"
              v-html="calcIndex(i, item)"
              :class="getAttrBody('tableindex', json.body, 'class')"
              :style="getAttrBody('tableindex', json.body, 'style')"
              class="px-3 py-4 whitespace-nowrap text-sm font-medium"
            ></td>
            <!-- data binding start -->
            <td
              v-for="key in json.keys"
              v-bind:key="key"
              :class="getAttrBody(key, json.body, 'class')"
              :style="getAttrBody(key, json.body, 'style')"
              class="px-3 py-4 whitespace-nowrap text-sm font-medium"
            >
              <!-- for action button -->
              <template v-if="key == 'action'">
                <div class="flex justify-center items-center">
                  <m-small-button
                    v-for="btn in item[key]"
                    :key="btn.title"
                    :data="btn"
                    :disabled="btn.disabled"
                    @modelHandle="modelHandle"
                  ></m-small-button>
                </div>
              </template>
              <!-- end action button -->
              <!-- for dynamic component -->
              <template
                v-else-if="key != 'checkbox' && checkComponent(item, key)"
              >
                <component
                  :is="item[key]['component']"
                  v-bind="item[key]['props']"
                  @nested-emit="nestedEmit"
                ></component>
              </template>
              <!-- dynamic component -->
              <!-- bind data by html -->
              <div
                v-if="
                  key != 'action' &&
                  key != 'checkbox' &&
                  !checkComponent(item, key)
                "
                :data-tooltip="getToolTipText(item)"
                v-html="getBodyText(item, key)"
              ></div>

              <!-- end data binding -->
                <!-- v-else-if="
                  key == 'checkbox' && checker.tab == $route.params.tab
                " -->
              <template
                v-else-if="hasChecker() && key == 'checkbox'"
              >
                <div class="relative flex items-start justify-start">
                  <div class="flex items-center h-5">
                    <input
                      v-tooltip="$t('message.' + checker.title)"
                      :id="`checkbox-${item['id']}`"
                      type="checkbox"
                      :value="item['id']"
                      v-model="checkData"
                      class="
                        focus:ring-indigo-500
                        h-4
                        w-4
                        text-indigo-600
                        border-gray-300
                        rounded
                        checker
                      "
                      @click="checkClick(item)"
                    />
                  </div>
                  <div class="ml-3 text-sm">
                    <label
                      :for="`checkbox-${item['id']}`"
                      class="font-medium text-gray-700"
                      v-html="checker.text"
                    ></label>
                  </div>
                </div>
              </template>
            </td>
          </tr>
          <tr v-if="json.body.data.length === 0">
            <td :colspan="json.header.data.length" class="bgc-grey-200">
              <div class="text-center py-3">{{ $t("message.no_data") }}</div>
            </td>
          </tr>
        </template>
        <tr v-else>
          <td :colspan="json.header.data.length" class="bgc-grey-200">
            <div class="flex flex justify-center py-4">
               <moon-loader
                size="40px"
                color="#4338ca">
                </moon-loader>
                {{ loadingMessage }}
            </div>
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr v-if="json.footer">
          <th
            v-for="(item, index) in json.footer.keys"
            v-bind:key="item"
            class="px-3 py-4 whitespace-nowrap"
            :class="getFooterAttr(json.footer, index, 'class')"
            :style="getFooterAttr(json.footer, index, 'style')"
            :colspan="getFooterAttr(json.footer, index, 'colspan')"
          >{{ getFooter(item, index) }}</th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
import ImageItem from '../components/UI/ImageItem.vue';

import helper from "../util/helper";
import { getMessage } from "../plugins/i18n";

export default {
  name: "FooTable",

  components: {
    ImageItem,
  },

  props: {
    index: {
      default: true,
      type: Boolean,
      required: false,
    },
    startIndex: {
      default: 0,
      type: Number,
      required: false,
    },
    json: {
      default: () => {},
      type: Object,
      required: true,
    },
    customHeader: {
      default: false,
      type: Boolean,
      required: false,
    },
    loading: {
      default: false,
      type: Boolean,
      required: false,
    },
    loadingMessage: {
      default: "loading...",
      type: String,
      required: false,
    },
    footableOption: {
      default: () => {},
      type: Object,
      required: false,
    },
    toolTipKey: {
      default: () => {},
      type: Object,
      required: false,
    },
    clickable: {
      default: () => {},
      type: Object,
      required: false,
    },
    tableClass: {
      default: "",
      type: String,
      required: false,
    },
    bodyClass: {
      default: "",
      type: String,
      required: false,
    },
    checker: {
      default: {
        check: false,
        history: [],
      },
      type: Object,
      required: false,
    },
  },

  watch: {
    ["json.body"]: {
      deep: true,
      handler() {
        if (this.hasData) {
          this.fillPreset();
        }
      },
    },
    ["checker.search_by_check_render"]: {
      deep: true,
      handler() {
        if (this.checker.search_by_check) {
          this.searchByCheck();
        }
      },
    },
  },

  data() {
    return {
      locale: "en",
      helper,
      footable: null,
      component: "image-item",
      checkData: [],
      checkCount: 0,
      loaded: true,
      loaderColor: 'text-indigo-500',
      loaderSize: '14px'
    };
  },

  computed: {
    hasData() {
      return this.json.body.data.length > 0;
    }
  },

  mounted() {
    this.locale = localStorage.getItem("locale")
      ? localStorage.getItem("locale")
      : "mm";
    if (this.checker.check) {
    }
  },

  methods: {
    fillPreset() {
      this.alreadyChecked();
    },
    searchByCheck() {
      if (this.checker.search_by_check) {
        let data = helper.findByKeyword(this.json.body.data, "tracking_code", this.checker.search_by_check);
        let checkbox = document.querySelector(`#checkbox-${data.id}`);
        if (!checkbox.checked) {
          checkbox.checked = true;
        } else {
          checkbox.checked = false;
        }
      }
    },
    modelHandle(status) {
      this.$emit("modelHandle", status);
    },
    getSortedStatus(key, index) {
      let arr = this.getFooterOption("ignoreSort");
      return arr ? (arr.indexOf(index) !== -1 ? "true" : "false") : "false";
    },
    getAttr(current, list, key) {
      if (list.attr) {
        let item;
        // calcualte '#' column
        if (this.index) {
          if (current > 0) {
            // for column index 1 and greater
            item = list.attr[this.json.keys[current - 1]];
          } else {
            // for column index 0 '#'
            item = list.attr["tableindex"];
          }
        } else {
          // not calculating index column
          item = list.attr[this.json.keys[current]];
        }
        if (item) {
          return item[key] ? item[key] : "";
        }
      }
      return "";
    },
    getHeader(item, index) {
      let html = this.getAttr(index, this.json.header, "html");
      let suffix = this.getAttr(index, this.json.header, "suffix");
      let type = this.getAttr(index, this.json.header, "type");

      let suffixText = "";
      if (suffix) {
        // suffixText = `${suffix.brackets ? "(" : ""} ${
        //   suffix.type == "lang"
        //     ? this.$lang.message[suffix.value]
        //     : suffix.value
        // } ${suffix.brackets ? ")" : ""}`;
        suffixText = `${suffix.brackets ? "(" : ""} ${
          suffix.type == "lang"
            ? this.$t(`message.${suffix.value}`)
            : suffix.value
        } ${suffix.brackets ? ")" : ""}`;
      }

      if (this.json.header.type == "lang") {
        item = this.$t(`message.${item}`);
      }

      return `${html} ${item} ${suffixText}`;
    },
    getFooterOption(key) {
      if (this.footableOption) {
        return this.footableOption[key];
      }
      return;
    },
    getRowAttr(item) {
      let classList = [];

      if (this.clickable) {
        classList.push("clickable");
      }

      if (item.row_attr) {
        classList.push(item.row_attr.class);
      }

      return classList.join(" ");
    },
    getFooter(item, index) {
      let value = this.json.footer.data[0][item];

      if (this.getFooterAttr(this.json.footer, index, "lang")) {
        return this.$t(value);
      }

      return value;
    },
    getFooterAttr(list, index, key) {
      let attrItem = list.attr[list.keys[index]];
      if (attrItem) {
        return attrItem[key];
      }
      return;
    },
    rowClick(item) {
      if (this.clickable) {
        this.$emit("row_click", item);
      }
    },
    calcIndex(index, item) {
      let i = index + this.startIndex;
      // i = this.$t(`message.${i}`);
      i = helper.localeNumbering(i, getMessage());
      if (helper.isInDevelop() && item.sup) {
        return `<span>${i}<sup>${item.sup}</sup></span>`;
      }

      return i;
    },
    getAttrBody(index, list, key) {
      if (list.attr && list.attr[index]) {
        return list.attr[index][key];
      }
    },
    checkComponent(item, key) {
      if (this.json.body.components) {
        return this.json.body.components[key];
      }
      return false;
    },
    getToolTipText(item) {
      if (this.toolTipKey) {
        return item[this.toolTipKey];
      }
      return undefined;
    },
    getBodyText(item, key) {
      let devData = item[`indev_${key}`];

      let suffix =
        helper.isInDevelop() && devData ? `<sup>(${devData})</sup>` : "";

      return `${item[key]}${suffix}`;
    },
    getTableClass() {
      return `${this.tableClass}`;
    },
    getBodyClass() {
      return `${this.bodyClass}`;
    },
    hasChecker() {
      if (this.$route.params.tab) {
        return this.checker.check && this.checker.tab == this.$route.params.tab;
      }
      return this.checker.check;
    },
    alreadyChecked() {
      this.checkData = [];
      if (this.checker.history.length > 0) {
        let checkedList = helper
        .getNestedValue("body.data", this.json, [])
        .map((item) => {
            return this.checker.history.includes(item.id) ? item.id : null;
        });

        this.checkData = helper.mergeArray(
          this.checkData,
          checkedList.filter((item) => item)
        );

        this.$emit("checkerClick", { ids: this.checkData, history: true });
      }

      let checkAll = document.querySelector("#checkbox-all");
      if (this.$route.params.tab == "pending" && this.checker.check) {
        if (this.checkData.length == this.json.body.data.length) {
          checkAll.checked = true;
        } else {
          checkAll.checked = false;
        }
      }
    },
    checkClick(data) {
      if (data == "checkbox-all") {
        this.checkAll();
      } else {
        this.checkCounter();
      }
      this.$emit("checkerClick", data);
    },
    checkAll() {
      this.checkData = [];
      let checkboxes = document.querySelectorAll("tbody .checker");
      let checkAll = document.querySelector("#checkbox-all");

      if (checkAll.checked) {
        this.checkCount = checkboxes.length;

        checkboxes.forEach((checkbox) => {
          this.checkData.push(parseInt(checkbox.value));
        });
      } else {
        this.checkCount = 0;
      }
    },
    checkCounter() {
      let checkboxes = document.querySelectorAll("tbody .checker");
      let checkAll = document.querySelector("#checkbox-all");
      checkAll.checked = false;
      this.checkCount = 0;

      if (!checkAll.checked) {
        checkboxes.forEach((checkbox) => {
          checkbox.checked ? this.checkCount++ : "";
        });
      }

      this.checkCount == this.checkData.length
        ? (checkAll.checked = true)
        : (checkAll.checked = false);
    },
  },
};
</script>
